import { AppThunk, RootState } from "../store";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { rdsEventGet } from "../../utils/rds";
import { apiUrls } from "../../components/shared/apiUrls";
import { rdsEventStatus_ResponseDto } from "../../interfaces/dtos/rdsEvent";
import { RdsState } from "./rdsSlice";
import { dateInReloadRange } from "../common/commonActions";

export const loadRdsEventStatusesFromMeeting = (
    meetingId: number
): AppThunk =>
    async (dispatch, getState) => {
        const meeting = getState().rds.rdsMeetings.find((m) => m.id === meetingId);
        if (!meeting) { return; }

        const events = getState().rds.rdsEvents.filter((e) => e.meetingId === meetingId);

        events?.forEach((e) => {
            if (mustReload(meeting.startDate, e.id, getState().rds)) {
                dispatch(loadRdsEventStatuses(e.id));
            }
        })
    };

const mustReload = (date: Date | string, eventId: number, rdsState: RdsState) => {
    if (dateInReloadRange(date)) {
        return true;
    }
    return !rdsState.rdsEventStatuses.some(es => es.id === eventId);
}

export const loadRdsEventStatuses = createAsyncThunk(
    'rds/loadRdsEventStatuses',
    async (eventId: number, { getState }) => {

        const response = await rdsEventGet<rdsEventStatus_ResponseDto>(
            `${apiUrls.rdsEvents.eventStatuses(eventId)}`
        );

        const { rds } = getState() as RootState;
        const otherEventStatuses = rds.rdsEventStatuses.filter((es) => es.id !== eventId);

        return [...otherEventStatuses, response.data];
    }
);
